// extracted by mini-css-extract-plugin
export default {"tooltip":"_6qCwy","showTooltip":"_3eRn8","tooltipLetgo":"_313-2","ellipsis":"_31kC9"};